// Production Configuration
export const config = {
  API_BASE_URL:
    process.env.NODE_ENV === 'development'
      ? '/api'
      : process.env.REACT_APP_API_URL,

  ENVIRONMENT: process.env.NODE_ENV || 'production',

  ENABLE_LOGGING: process.env.NODE_ENV === 'development',

  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
};

// API Configuration
export const API_CONFIG = {
  baseURL: config.API_BASE_URL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Feature Flags
export const FEATURES = {
  ENABLE_ANALYTICS: config.ENVIRONMENT === 'production',
  ENABLE_DEBUG_MODE: config.ENVIRONMENT === 'development',
  ENABLE_PERFORMANCE_MONITORING: config.ENVIRONMENT === 'production',
};

// Debug
console.log('🌍 ENV:', config.ENVIRONMENT);
console.log('🔗 API URL:', config.API_BASE_URL);